import { SlotProps } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import React from 'react';

import ClosedEye from '@/assets/icons/eye-closed.svg?react';
import OpenedEye from '@/assets/icons/eye-open.svg?react';

interface Props {
  readonly value: string;
  readonly label: string;
  readonly fullWidth: boolean;
  readonly error?: boolean;
  readonly autoComplete: 'new-password' | 'current-password' | 'password';

  onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

export const CustomPasswordInput: React.FC<Props> = (props: Props): React.ReactElement => {
  const { value, label, fullWidth, error, autoComplete, onChange } = props;
  const [type, setType] = React.useState<'text' | 'password'>('password');

  const showPassword = React.useCallback((): void => {
    setType('text');
  }, []);

  const hidePassword = React.useCallback((): void => {
    setType('password');
  }, []);

  const slotProps = React.useMemo(
    (): SlotProps<any, any, any> => ({
      input: {
        endAdornment: (
          <InputAdornment position="end">
            <IconButton tabIndex={-1}>
              {type === 'password' ? (
                <OpenedEye onClick={showPassword} />
              ) : (
                <ClosedEye onClick={hidePassword} />
              )}
            </IconButton>
          </InputAdornment>
        ),
      },
    }),
    [hidePassword, showPassword, type],
  );

  return (
    <TextField
      value={value}
      label={label}
      fullWidth={fullWidth}
      error={error}
      type={type}
      autoComplete={autoComplete}
      slotProps={slotProps}
      onChange={onChange}
    />
  );
};
